import { Color } from '../enums/Color';

const deliveryZoneColorMap: Record<number, Color> = {
  1: Color.Violet,
  2: Color.Pink,
  3: Color.Turquoise,
  4: Color.Green,
  5: Color.Orange,
  6: Color.Yellow,
  7: Color.AzureBlue,
  8: Color.JokerBlue,
  9: Color.Red,
  10: Color.Brown,
  11: Color.MutedGreen,
  12: Color.DarkViolet,
  13: Color.DarkPink,
  14: Color.WarmGrey,
  15: Color.OliveGreen
};

export default deliveryZoneColorMap;
